import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useMutation, useQueryClient} from 'react-query';
import { fetcher } from 'api/client';
import { updateProfile } from 'api/actions/profile';
import { useProfileState } from 'context/profile';
import { Form, Row, Col } from 'reactstrap';

export default function General() {
    const { t } = useTranslation();

    const queryClient = useQueryClient();
    const { profile } = useProfileState();
    const { register, handleSubmit, reset, errors } = useForm();
    const { mutate: profileMutation } = useMutation((payload) => fetcher(updateProfile(payload)), {
        onSuccess: () => {
            queryClient.invalidateQueries('profile');
            // toast.success(t('success'));
        }
    });

    const onSubmit = (payload) => {
        if (payload.language) localStorage.setItem('user-language', payload.language);
        profileMutation(payload);
    }
    const buttonRef = useRef();

    const doSubmit = () => buttonRef.current.click()

    useEffect(() => {
        if (profile?.language) {
            reset({ language: profile?.language })
        }
    }, [profile?.language, reset])

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <h5 className="mb-3">
                <i className="fas fa-user"></i> {t('profile.personal.info')}
            </h5>
            <Row>
                <Col md="4">
                    <div className="form-group">
                        <label>{t('profile.personal.name')}</label>
                        <input
                            ref={register({ required: true, maxLength: 50 })}
                            onBlur={doSubmit}
                            type="text"
                            className="form-control"
                            placeholder={t('profile.personal.name_placeholder')}
                            autoComplete="new-name"
                            name="givenName"
                            defaultValue={profile.givenName}
                        />
                        {errors.givenName && t('errors.maxLength')}
                    </div>
                </Col>
                <Col md="4">
                    <div className="form-group">
                        <label>{t('profile.personal.last_name')}</label>
                        <input
                            ref={register({ required: true, maxLength: 50})}
                            onBlur={doSubmit}
                            type="text"
                            className="form-control"
                            placeholder={t('profile.personal.last_name_placeholder')}
                            autoComplete="new-name"
                            name="familyName"
                            defaultValue={profile.familyName}
                            />
                        {errors.familyName && t('errors.maxLength')}
                    </div>
                </Col>
                <Col md="4">
                    <div className="form-group">
                        <label>{t('profile.personal.phone')}</label>
                        <input
                            ref={register}
                            onBlur={doSubmit}
                            type="text"
                            className="form-control"
                            placeholder={t('profile.personal.phone_placeholder')}
                            autoComplete="new-phone"
                            defaultValue={profile.phone}
                            name="phone" />
                    </div>
                </Col>
            </Row>
            <hr></hr>
            <h5 className="mb-3">
                <i className="fas fa-language"></i> {t('profile.settings.language')}
            </h5>
            <Row>
                <Col md="12">
                    <div className="form-group">
                        <label>{t('profile.settings.language')}</label>
                        <select
                            ref={register}
                            onChange={doSubmit}
                            className="form-control"
                            name="language">
                            <option value="es" >{t('profile.settings.lang_es')}</option>
                            <option value="en" >{t('profile.settings.lang_en')}</option>
                            <option value="pt" >{t('profile.settings.lang_pt')}</option>
                            <option value="de" >{t('profile.settings.lang_de')}</option>
                        </select>
                    </div>
                </Col>
            </Row>

            <hr></hr>
            <h5 className="mb-3">
                <i className="fas fa-bell"></i> {t('editor.notifications.title')}
            </h5>
            <Row>
                <div className="col-md-12">
                    <div className="d-flex ml-1 align-items-center">
                        <input
                            ref={register}
                            onChange={doSubmit}
                            type="checkbox"
                            id="notify.expiry"
                            name="notify.expiry"
                            defaultChecked={profile?.notify?.expiry}
                            style={{ width: 'auto' }} />
                        <span className="ml-1 mt-1">{t('profile.settings.notify_expiry')}</span>
                    </div>
                </div>
            </Row>

            <hr></hr>
            <button type="submit" className="btn btn-primary d-none" ref={buttonRef}>{t('profile.save')}</button>
        </Form>
    );
}
